/******************************************************
 *                  Timetables Ctrl
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("ExploitTimetablesNewCtrl", ["$scope", "$controller", function ($scope, $controller) {


		$controller("ExploitTimetablesEditOrNewParentCtrl", {$scope: $scope});

		$scope.data.mode = "add";

	}]);
